import React, { memo, useEffect } from 'react';
import get from 'lodash/get';
import { string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSurveyOutcomes } from './slice';
import OutcomesTable from './OutcomesTable';
import OutcomesChart from './OutcomesChart';

function OutComesView(props) {
  const dispatch = useDispatch();
  const surveyId = props.surveyId || get(props, 'match.params.surveyId', '');
  const patientId = props.patientId || get(props, 'match.params.patientId', '');

  useEffect(() => {
    if (patientId && surveyId) {
      dispatch(fetchSurveyOutcomes({ patientId, surveyId }));
    }
  }, []);
  return (
    <div style={{ background: '#fff', height: '100vh', marginBottom: 20 }}>
      <OutcomesChart patientId={patientId} showClose={props.showClose} />
      <OutcomesTable />
    </div>
  );
}

OutComesView.propTypes = {};

export default memo(OutComesView);
